/**
 * Single source of truth for all application roles (frontend mirror).
 *
 * This file mirrors the backend constants at:
 *   C-Back-End/src/common/constants/roles.ts
 *
 * When adding a new role, add it to BOTH files.
 *
 * Usage:
 *   import { ROLES } from '@/constants/roles';
 *   authUtils.hasRole(ROLES.ADMIN.slug)
 */

export const ROLES = {
  OWNER: { slug: 'role-owner', name: 'Account Owner' },
  ADMIN: { slug: 'role-admin', name: 'Administrator' },
  SALES_REP: { slug: 'role-representative', name: 'Sales Representative' },
  SALES_MANAGER: { slug: 'role-manager', name: 'Sales Manager' },
  ESTIMATOR: { slug: 'role-estimator', name: 'Estimator' },
  /**
   * Payables / Transactions and Receivables (bookkeeper work).
   * Must stay byte-for-byte identical to C-Back-End Goal 1.
   * Do not invent a second name (not "Lark Staff", not "Accountant").
   */
  BOOKKEEPER: { slug: 'role-bookkeeper', name: 'Bookkeeper' },
  ARCHITECT: { slug: 'role-architect', name: 'Architect' },
  SUBCONTRACTOR: { slug: 'role-subcontractor', name: 'Subcontractor' },
  RECEPTIONIST: { slug: 'role-receptionist', name: 'Receptionist' },
  MARKETING_MANAGER: { slug: 'role-marketing-manager', name: 'Marketing Manager' },
  /**
   * Projects module — the field production owner. Never holds
   * BUDGET.VIEW_FINANCIALS, so production payloads arrive with amounts
   * already stripped and `canViewFinancials: false`.
   */
  PROJECT_MANAGER: { slug: 'role-project-manager', name: 'Project Manager' },
} as const;

export type RoleSlug = (typeof ROLES)[keyof typeof ROLES]['slug'];
export type RoleName = (typeof ROLES)[keyof typeof ROLES]['name'];
